import React, { Component, Fragment } from 'react';
import { Input } from 'reactstrap';

import WordCount from './WordCount';

const maxLength = 140;

export default class InputWithWordCount extends Component {
  state = {
    value: this.props.value,
    focused: false,
  };

  handleChange = e => this.setState({ value: e.target.value });

  render() {
    const { value, focused } = this.state;
    return (
      <Fragment>
        <Input
          value={value}
          onChange={this.handleChange}
          maxLength={maxLength}
          onFocus={this.toggleFocus}
          onBlur={this.toggleFocus}
          ref={this.props.inputRef}
        />
        {focused && <WordCount maxChar={maxLength} charCount={value.length} />}
      </Fragment>
    );
  }

  toggleFocus = () =>
    this.setState({
      focused: !this.state.focused,
    });
}



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Editors/Highlights/InputWithWorldCount.jsx